import { Link } from "react-router-dom"
import LoginForm from "../components/auth/LoginForm"
import BrandLogo from "../components/ui/BrandLogo"

export default function LoginPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-dantzBlue px-6 py-12">
      <Link to="/home" aria-label="Go to dashboard">
        <BrandLogo />
      </Link>

      <LoginForm />

      <div className="mt-8 flex gap-3 text-xs tracking-widest text-secondary5">
        <span>TRADEMARK</span>
        <span className="text-dantzOrange">·</span>
        <span>DESIGN</span>
        <span className="text-dantzOrange">·</span>
        <span>PATENT</span>
      </div>
    </div>
  )
}
